import { styled } from 'styled-components';
import { breakpoints } from 'config/config';
import { Flex } from 'antd';

export const StyledCartPage = styled('div')`
  .container {
    padding: 0 20px 20px 20px;
    background-color: ${(props) => props.theme.whiteBackground};
    border-radius: 15px;

    .ant-divider {
      margin: 12px 0 0 0;
    }
  }

  .cart-page-title {
    display: block;
    font-family: ${(props) => props.theme.fontText};

    h1 {
      font-size: 2.625em;
      margin-block-start: 0;
      margin-block-end: 0;
      padding-top: 0.32em;
      padding-bottom: 1.28em;
      font-weight: 500;
    }

    &.mobile {
      color: ${(props) => props.theme.black};
      display: none;
      h1 {
        font-size: 18px;
        font-weight: 600;
      }
    }
  }

  .back-button {
    display: none;
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    .container {
      padding-bottom: 0;

      .ant-divider {
        display: none;
      }
    }

    .back-button {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 17px 0px 17px 20px;
      border-bottom: none;
      font-size: 0.875rem;
      font-weight: 400;
      div {
        display: flex;
        height: 17px;
        width: 17px;
      }
    }

    div[class*='ant-steps'] {
      display: none;
    }

    .cart-page-title {
      display: none;
      font-size: 18px;

      h1 {
        margin: 10px 0;
      }

      &.mobile {
        display: block;
        margin-bottom: 10px;

        h1 {
          margin: 0;
          padding: 20px 0;
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .cart-order-summary-wrapper {
      padding: 0 !important;
    }
  }
`;

export const StyledWholesalePaymentBlock = styled(Flex)`
  background: ${(props) => props.theme.loginBackgroundColor};
  padding: 20px;
  border-radius: 5px;

  .ant-btn {
    height: 52px;
    font-weight: 700;
  }

  .cart-summary-final-price {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-right: 70px;

    .cart-summary-price {
      font-weight: 700;
    }

    .mobile-label {
      display: none;
    }
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    position: fixed;
    bottom: 70px;
    left: 0;
    width: 100vw;
    z-index: 10;
    border-radius: 15px;
    padding: 31px 20px 61px 20px;
    background: ${(props) => props.theme.navDark};
    flex-wrap: wrap;
    gap: 15px;

    .cart-summary-final-price {
      width: 100%;
      justify-content: space-between;
      margin-right: 0;
      margin-bottom: 10px;

      .cart-summary-final-price-title,
      .cart-summary-price {
        color: ${(props) => props.theme.white};
      }

      .desktop-label {
        display: none;
      }

      .mobile-label {
        display: inline;
      }
    }

    > *:not(.cart-summary-final-price) {
      flex: 1 1 0;
      min-width: 0;
    }

    .ant-btn {
      width: 100%;
      border-radius: 20px;
      height: 44px;
    }

    .delivery-button {
      background-color: ${(props) => props.theme.wholesale};
      border-color: ${(props) => props.theme.wholesale};
      color: ${(props) => props.theme.white};

      &.delivery-configured {
        background-color: ${(props) => props.theme.wholesale};
        border-color: ${(props) => props.theme.wholesale};
        color: ${(props) => props.theme.white};
      }
    }

    .cart-summary-submit-btn {
      background-color: ${(props) => props.theme.wholesale};
      border-color: ${(props) => props.theme.wholesale};
      color: ${(props) => props.theme.white};

      &:disabled {
        background-color: ${(props) => props.theme.wholesale};
        border-color: ${(props) => props.theme.wholesale};
        color: ${(props) => props.theme.white};
        opacity: 0.4;
      }

      &:hover {
        background-color: ${(props) => props.theme.wholesale};
        border-color: ${(props) => props.theme.wholesale};
        color: ${(props) => props.theme.white};
      }
    }
  }
`;

export const StyledNotification = styled('div')`
  display: flex;
  align-items: center;

  height: 75px;
  background-color: ${(props) => props.theme.eMarket};
  padding: 0 18px;
  border-radius: 5px;

  color: ${(props) => props.theme.white};
  font-weight: 300;
  font-size: 16px;
`;
